import * as React from "react";
import history from "../../../history";
import { Organization } from "../../organizations/types";
import MultiOrgSelect from "../components/MultiOrgSelect";
import { connect } from "react-redux";
import { RootState } from "../../types";
import { setCurrentOrg } from "../actions";
import { fetchCurrentUser } from "../../session/actions";
import "./Organizations.scss";

interface StoreProps {
  currentOrganization: Organization | null;
  organizations: Organization[] | null;
  loading: boolean;
  errorMessage: string | null;
}

interface DispatchProps {
  setCurrentOrg: (org: Organization) => void;
  fetchCurrentUser: () => void;
}

type Props = StoreProps & DispatchProps;

class MultiOrgSelectContainer extends React.PureComponent<Props> {
  public setCurrentOrgAndPush = (org: Organization) => {
    this.props.setCurrentOrg(org);
    if (history.location.pathname != "/changeOrganization/") {
      history.push(history.location.pathname);
    } else {
      history.goBack();
    }
  };

  public render() {
    return <MultiOrgSelect {...this.props} setCurrentOrg={this.setCurrentOrgAndPush} />;
  }
}

export default connect<StoreProps, DispatchProps, {}, RootState>(
  state => ({
    loading: state.orgs.loading,
    errorMessage: state.orgs.errorMessage,
    organizations: state.orgs.data,
    currentOrganization: state.orgs.currentOrganization
  }),
  { setCurrentOrg, fetchCurrentUser }
)(MultiOrgSelectContainer);
